/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "_lpTokenName",
                type: "string",
            },
            {
                internalType: "string",
                name: "_lpTokenSymbol",
                type: "string",
            },
            {
                internalType: "address",
                name: "_bridgeAdmin",
                type: "address",
            },
            {
                internalType: "address",
                name: "_l1Token",
                type: "address",
            },
            {
                internalType: "uint64",
                name: "_lpFeeRatePerSecond",
                type: "uint64",
            },
            {
                internalType: "bool",
                name: "_isWethPool",
                type: "bool",
            },
            {
                internalType: "address",
                name: "_timer",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "BridgePoolAdminTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "depositHash",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "chainId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "depositId",
                        type: "uint64",
                    },
                    {
                        internalType: "address payable",
                        name: "l1Recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "l2Sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "slowRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "instantRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "quoteTimestamp",
                        type: "uint32",
                    },
                ],
                indexed: false,
                internalType: "struct BridgePool.DepositData",
                name: "depositData",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "enum BridgePool.RelayState",
                        name: "relayState",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "slowRelayer",
                        type: "address",
                    },
                    {
                        internalType: "uint32",
                        name: "relayId",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "realizedLpFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "priceRequestTime",
                        type: "uint32",
                    },
                    {
                        internalType: "uint256",
                        name: "proposerBond",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "finalFee",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct BridgePool.RelayData",
                name: "relay",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "relayAncillaryDataHash",
                type: "bytes32",
            },
        ],
        name: "DepositRelayed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lpTokensMinted",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidityProvider",
                type: "address",
            },
        ],
        name: "LiquidityAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lpTokensBurnt",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidityProvider",
                type: "address",
            },
        ],
        name: "LiquidityRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "newLpFeeRatePerSecond",
                type: "uint64",
            },
        ],
        name: "LpFeeRateSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "depositHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "relayHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "disputer",
                type: "address",
            },
        ],
        name: "RelayCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "depositHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "relayHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "disputer",
                type: "address",
            },
        ],
        name: "RelayDisputed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "depositHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum BridgePool.RelayState",
                        name: "relayState",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "slowRelayer",
                        type: "address",
                    },
                    {
                        internalType: "uint32",
                        name: "relayId",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "realizedLpFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "priceRequestTime",
                        type: "uint32",
                    },
                    {
                        internalType: "uint256",
                        name: "proposerBond",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "finalFee",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct BridgePool.RelayData",
                name: "relay",
                type: "tuple",
            },
        ],
        name: "RelaySettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "depositHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "instantRelayer",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum BridgePool.RelayState",
                        name: "relayState",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "slowRelayer",
                        type: "address",
                    },
                    {
                        internalType: "uint32",
                        name: "relayId",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "realizedLpFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "priceRequestTime",
                        type: "uint32",
                    },
                    {
                        internalType: "uint256",
                        name: "proposerBond",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "finalFee",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct BridgePool.RelayData",
                name: "relay",
                type: "tuple",
            },
        ],
        name: "RelaySpedUp",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "newRelaysEnabled",
                type: "bool",
            },
        ],
        name: "RelaysEnabledSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "l1TokenAmount",
                type: "uint256",
            },
        ],
        name: "addLiquidity",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bonds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bridgeAdmin",
        outputs: [
            {
                internalType: "contract BridgeAdminInterface",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newAdmin",
                type: "address",
            },
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "chainId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "depositId",
                        type: "uint64",
                    },
                    {
                        internalType: "address payable",
                        name: "l1Recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "l2Sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "slowRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "instantRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "quoteTimestamp",
                        type: "uint32",
                    },
                ],
                internalType: "struct BridgePool.DepositData",
                name: "depositData",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "enum BridgePool.RelayState",
                        name: "relayState",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "slowRelayer",
                        type: "address",
                    },
                    {
                        internalType: "uint32",
                        name: "relayId",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "realizedLpFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "priceRequestTime",
                        type: "uint32",
                    },
                    {
                        internalType: "uint256",
                        name: "proposerBond",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "finalFee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgePool.RelayData",
                name: "relayData",
                type: "tuple",
            },
        ],
        name: "disputeRelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "exchangeRateCurrent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getAccumulatedFees",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "relayedAmount",
                type: "uint256",
            },
        ],
        name: "getLiquidityUtilization",
        outputs: [
            {
                internalType: "uint256",
                name: "utilizationCurrent",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "utilizationPostRelay",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "chainId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "depositId",
                        type: "uint64",
                    },
                    {
                        internalType: "address payable",
                        name: "l1Recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "l2Sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "slowRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "instantRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "quoteTimestamp",
                        type: "uint32",
                    },
                ],
                internalType: "struct BridgePool.DepositData",
                name: "depositData",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "enum BridgePool.RelayState",
                        name: "relayState",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "slowRelayer",
                        type: "address",
                    },
                    {
                        internalType: "uint32",
                        name: "relayId",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "realizedLpFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "priceRequestTime",
                        type: "uint32",
                    },
                    {
                        internalType: "uint256",
                        name: "proposerBond",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "finalFee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgePool.RelayData",
                name: "relayData",
                type: "tuple",
            },
        ],
        name: "getRelayAncillaryData",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "identifier",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "instantRelays",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isWethPool",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "l1Token",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastLpFeeUpdate",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidReserves",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidityUtilizationCurrent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "relayedAmount",
                type: "uint256",
            },
        ],
        name: "liquidityUtilizationPostRelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lpFeeRatePerSecond",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "results",
                type: "bytes[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "numberOfRelays",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "optimisticOracle",
        outputs: [
            {
                internalType: "contract SkinnyOptimisticOracleInterface",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "optimisticOracleLiveness",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingReserves",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposerBondPct",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "chainId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "depositId",
                        type: "uint64",
                    },
                    {
                        internalType: "address payable",
                        name: "l1Recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "l2Sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "slowRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "instantRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "quoteTimestamp",
                        type: "uint32",
                    },
                ],
                internalType: "struct BridgePool.DepositData",
                name: "depositData",
                type: "tuple",
            },
            {
                internalType: "uint64",
                name: "realizedLpFeePct",
                type: "uint64",
            },
        ],
        name: "relayAndSpeedUp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "chainId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "depositId",
                        type: "uint64",
                    },
                    {
                        internalType: "address payable",
                        name: "l1Recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "l2Sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "slowRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "instantRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "quoteTimestamp",
                        type: "uint32",
                    },
                ],
                internalType: "struct BridgePool.DepositData",
                name: "depositData",
                type: "tuple",
            },
            {
                internalType: "uint64",
                name: "realizedLpFeePct",
                type: "uint64",
            },
        ],
        name: "relayDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "relays",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "relaysEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "lpTokenAmount",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "sendEth",
                type: "bool",
            },
        ],
        name: "removeLiquidity",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "time",
                type: "uint256",
            },
        ],
        name: "setCurrentTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "_newLpFeeRatePerSecond",
                type: "uint64",
            },
        ],
        name: "setLpFeeRatePerSecond",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_relaysEnabled",
                type: "bool",
            },
        ],
        name: "setRelaysEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "chainId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "depositId",
                        type: "uint64",
                    },
                    {
                        internalType: "address payable",
                        name: "l1Recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "l2Sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "slowRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "instantRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "quoteTimestamp",
                        type: "uint32",
                    },
                ],
                internalType: "struct BridgePool.DepositData",
                name: "depositData",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "enum BridgePool.RelayState",
                        name: "relayState",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "slowRelayer",
                        type: "address",
                    },
                    {
                        internalType: "uint32",
                        name: "relayId",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "realizedLpFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "priceRequestTime",
                        type: "uint32",
                    },
                    {
                        internalType: "uint256",
                        name: "proposerBond",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "finalFee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgePool.RelayData",
                name: "relayData",
                type: "tuple",
            },
        ],
        name: "settleRelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "chainId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "depositId",
                        type: "uint64",
                    },
                    {
                        internalType: "address payable",
                        name: "l1Recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "l2Sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "slowRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "instantRelayFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "quoteTimestamp",
                        type: "uint32",
                    },
                ],
                internalType: "struct BridgePool.DepositData",
                name: "depositData",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "enum BridgePool.RelayState",
                        name: "relayState",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "slowRelayer",
                        type: "address",
                    },
                    {
                        internalType: "uint32",
                        name: "relayId",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "realizedLpFeePct",
                        type: "uint64",
                    },
                    {
                        internalType: "uint32",
                        name: "priceRequestTime",
                        type: "uint32",
                    },
                    {
                        internalType: "uint256",
                        name: "proposerBond",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "finalFee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgePool.RelayData",
                name: "relayData",
                type: "tuple",
            },
        ],
        name: "speedUpRelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "store",
        outputs: [
            {
                internalType: "contract StoreInterface",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sync",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "syncUmaEcosystemParams",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "syncWithBridgeAdminParams",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "timerAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "undistributedLpFees",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "utilizedReserves",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
export class BridgePool__factory extends ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(_lpTokenName, _lpTokenSymbol, _bridgeAdmin, _l1Token, _lpFeeRatePerSecond, _isWethPool, _timer, overrides) {
        return super.deploy(_lpTokenName, _lpTokenSymbol, _bridgeAdmin, _l1Token, _lpFeeRatePerSecond, _isWethPool, _timer, overrides || {});
    }
    getDeployTransaction(_lpTokenName, _lpTokenSymbol, _bridgeAdmin, _l1Token, _lpFeeRatePerSecond, _isWethPool, _timer, overrides) {
        return super.getDeployTransaction(_lpTokenName, _lpTokenSymbol, _bridgeAdmin, _l1Token, _lpFeeRatePerSecond, _isWethPool, _timer, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
BridgePool__factory.bytecode = _bytecode;
BridgePool__factory.abi = _abi;
